var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioVolumeLevel5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 9,
    y: 7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.5C7.5 2.01 9.51 0 12 0C14.49 0 16.5 2.01 16.5 4.5V12C16.5 14.49 14.49 16.5 12 16.5C9.51 16.5 7.5 14.49 7.5 12V4.5ZM12 15C13.65 15 15 13.65 15 12V4.5C15 2.85 13.65 1.5 12 1.5C10.35 1.5 9 2.85 9 4.5V12C9 13.65 10.35 15 12 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.485 12.15C19.5 12.105 19.5 12.045 19.5 12C19.5 11.58 19.17 11.25 18.75 11.25C18.33 11.25 18 11.58 18 12C18 15.315 15.315 18 12 18C8.685 18 6 15.315 6 12C6 11.58 5.67 11.25 5.25 11.25C4.83 11.25 4.5 11.58 4.5 12C4.5 12.045 4.5 12.105 4.515 12.15C4.575 15.96 7.5 19.08 11.25 19.455V22.5H8.25C7.83 22.5 7.5 22.83 7.5 23.25C7.5 23.67 7.83 24 8.25 24H15.75C16.17 24 16.5 23.67 16.5 23.25C16.5 22.83 16.17 22.5 15.75 22.5H12.75V19.455C16.5 19.08 19.425 15.96 19.485 12.15Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)",
    style: {}
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 12 15 C 13.65 15 15 13.65 15 12 V 4.5 C 15 2.85 13.65 1.5 12 1.5 C 10.35 1.5 9 2.85 9 4.5 V 12 C 9 13.65 10.35 15 12 15 Z",
    fill: "#23D959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioVolumeLevel5);
export default __webpack_public_path__ + "static/media/audio-volume-level5.cc9651837725c4bdb5122e702dcba241.svg";
export { ForwardRef as ReactComponent };